import Vue from "vue";
import { groupingRelationshipItem } from "@/models/groupingRelationshipItem";
import { groupItem } from "@/models/groupItem";
import { Component, Prop, Watch } from "vue-property-decorator";
import { tableItemConfig, importConfig } from "../models/tableConfigs";
import api from "@/services/api";
import { BListGroupItem } from "bootstrap-vue";
import helpers from "@/utils";
import { configTypes } from "@/enums/configTypes";
import { childTypes } from "@/enums/childTypes";

@Component({})
export default class groupingPage extends Vue {
	tables: tableItemConfig[] = [];
	groups: groupItem[] = [];
	groupingRelationships: groupingRelationshipItem[] = [];

	searchTable: string = null;
	searchGroup: string = null;

	groupNew: groupItem = new groupItem();
	groupNewSaveClick: boolean = false;
	groupNewSaveLoading: boolean = false;
	showModalNewGroup: boolean = false;

	groupSelected: groupItem = new groupItem();
	groupingSelectedRelationships: groupingRelationshipItem[] = [];

	get groupNewDescriptionValidation(): boolean {
		if (!this.groupNewSaveClick) return null;
		return this.groupNew.name.length > 0;
	}

	get groupName(): string {
		return this.groupSelected && this.groupSelected.name ? this.groupSelected.name : "seleziona un gruppo per configurarlo";
	}

	get tableList(): tableItemConfig[] {
		var self = this;
		if (self.tables == null) return [];
		if (self.searchTable == null) return self.tables;
		var filtered = self.tables.filter(x => (x.friendlyName || "").indexOf(self.searchTable) != -1);
		return filtered;
	}

	get groupList(): groupItem[] {
		var self = this;
		if (self.groups == null) return [];
		if (self.searchGroup == null) return self.groups;
		var filtered = self.groups.filter(x => (x.name || "").indexOf(self.searchGroup) != -1);
		return filtered;
	}

	created() {
		var self = this;
		self.fetch();
	}
	fetch() {
		var self = this;

		api.getGroupings().then(data => {
			self.tables = data.tables;

			if (self.tables && self.tables.length > 0) {
				self.tables.forEach(item => {
					Vue.set(item, "expanded", false);
				});
			}

			self.groups = data.groups;
			//self.groupingRelationships = data.groupingRelationships;
		});
	}

	isActive(g: groupItem) {
		return g != null && g.name == this.groupName;
	}

	setGroupSelected(g: groupItem) {
		this.groupSelected = g;
	}

	openModalNewGroup() {
		this.groupNew = new groupItem();
		this.showModalNewGroup = true;
	}

	onSaveNewGroup() {
		if (this.groupNew.name.length == 0) {
			this.groupNewSaveClick = true;
			this.$bvToast.toast("la descrizione è obbligatoria", {
				variant: "danger",
				title: "ATTENZIONE",
				solid: true
			});
			return null;
		}

		var self = this;
		api.saveNewGroup(this.groupNew).then(res => {
			self.onCancelNewGroup();
			self.groupSelected = new groupItem();
			self.fetch();
		});
	}

	onCancelNewGroup() {
		this.groupNew = new groupItem();
		this.showModalNewGroup = false;
		this.groupNewSaveClick = false;
	}

	onElementAdd(evt: any) {
		if (evt && evt.added && evt.added.element && evt.added.element.length > 0) {
			this.groupSelected.groupItemRelationships.splice(evt.added.newIndex, 1);

			evt.added.element.forEach((element, index) => {
				this.groupSelected.groupItemRelationships.splice(evt.added.newIndex + index, 0, element);
			});
		}
	}

	cloneItem(item: any) {
		if (item) {
			switch (item.configType) {
				case configTypes.Table:
					if (item.configs.length > 0) {
						let cloneItems: groupingRelationshipItem[] = [];
						item.configs.forEach((config: importConfig) => {
							let cloneItem: groupingRelationshipItem = new groupingRelationshipItem();
							cloneItem.itemID = 0;
							cloneItem.parentID = null;
							cloneItem.childType = childTypes.Table;
							cloneItem.itemName = `${config.description} - ${config.importType}`;
							cloneItem.childID = config.itemID;

							cloneItems.push(cloneItem);
						});

						return cloneItems;
					} else {
						this.$bvToast.toast("non ci sono configurazione da trasferire", {
							variant: "danger",
							title: "ATTENZIONE",
							solid: true
						});

						return null;
					}
					break;
				case configTypes.Configruation:
					let itemC = item as importConfig;
					let cloneItem: groupingRelationshipItem = new groupingRelationshipItem();
					cloneItem.itemID = 0;
					cloneItem.parentID = null;
					cloneItem.childType = childTypes.Table;
					cloneItem.itemName = `${itemC.description} - ${itemC.importType}`;
					cloneItem.childID = itemC.itemID;

					return cloneItem;
					break;
				case configTypes.Group:
					let group = item as groupItem;

					if (group.itemID != this.groupSelected.itemID) {
						let cloneGroupItem: groupingRelationshipItem = new groupingRelationshipItem();
						cloneGroupItem.itemID = 0;
						cloneGroupItem.parentID = null;
						cloneGroupItem.childType = childTypes.Group;
						cloneGroupItem.itemName = group.name;
						cloneGroupItem.childID = group.itemID;

						return cloneGroupItem;
					}

					this.$bvToast.toast("non è possibile inserire un gruppo in se stesso", {
						variant: "danger",
						title: "ATTENZIONE",
						solid: true
					});

					return null;
					break;

				default:
					this.$bvToast.toast("oggetto da spostare non riconosciuto", {
						variant: "danger",
						title: "ATTENZIONE",
						solid: true
					});
					break;
			}
		}
	}
	onMoveTableOn(item) {
		if (item && item.draggedContext && item.draggedContext.element && item.draggedContext.element.configs.length > 0) {
			return true;
		}

		return false;
	}
	onMoveGroupOn(item) {
		if (item && item.draggedContext && item.draggedContext.element && item.draggedContext.element.itemID != this.groupSelected.itemID) {
			return true;
		}

		return false;
	}
	removeAtIndex(index: number) {
		if (index >= 0) {
			this.groupSelected.groupItemRelationships.splice(index, 1);
		}
	}
	onDelete() {
		var self = this;
		this.$bvModal
			.msgBoxConfirm(`Sei sicuro di eliminare il gruppo ${this.groupSelected.name} ?`, {
				title: "ATTENZIONE",
				okTitle: "SI",
				cancelTitle: "NO",
				footerClass: "p-2",
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if (value) {
					api.deleteGroup(this.groupSelected.itemID).then(res => {
						self.groupSelected = new groupItem();

						this.$bvToast.toast("Gruppo eliminato correttamente", {
							variant: "success",
							title: "Operazione eseguita",
							solid: true
						});

						self.fetch();
					});
				}
			})
			.catch(err => {
				console.log(err);
			});
	}
	onSave() {
		var self = this;
		api.updateGroup(this.groupSelected).then(res => {
			this.$bvToast.toast("Salvataggio eseguito con successo", {
				variant: "success",
				title: "Operazione eseguita",
				solid: true
			});

			self.groupSelected = new groupItem();
			self.fetch();
		});
	}
}
